import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { IRequestContextService } from './IRequestContextService';

@Injectable({
    providedIn: 'root'
})
export class RequestContextService implements IRequestContextService {
    public static $name: string = 'requestContextService';

    public getRequestContext(baseName: string) {
        return `${baseName}-${_.uniqueId()}`;
    }
}
